export default __webpack_public_path__ + "static/media/carte.f8e92d93.png";